var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgResplusicon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3531",
    "data-name": "Group 3531",
    transform: "translate(-2276 -2678)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_298",
    "data-name": "Ellipse 298",
    cx: 14,
    cy: 14,
    r: 14,
    transform: "translate(2276 2678)",
    fill: "#d10a11"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(2278 2680)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "plus"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1203",
    "data-name": "Rectangle 1203",
    width: 24,
    height: 24,
    transform: "translate(24 24) rotate(180)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4614",
    "data-name": "Path 4614",
    d: "M19,11H13V5a1,1,0,0,0-2,0v6H5a1,1,0,0,0,0,2h6v6a1,1,0,0,0,2,0V13h6a1,1,0,0,0,0-2Z",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResplusicon);
export default __webpack_public_path__ + "static/media/resplusicon.643ff9f438eb8325a6249f219588d635.svg";
export { ForwardRef as ReactComponent };